import { type default as MailboxRank, MailboxRanksSet } from './MailboxRank';

export default function isMailboxRank(rank?: string | null): rank is MailboxRank {
    return typeof rank === 'string' && MailboxRanksSet.has(rank);
}
